import { BacsModal, FailedIcon, MerchantButton } from "@components";
import { useNavigate } from "react-router-dom";

const PaymentFailed = ({ merchant, reference, retryUrl, onReturn, showBacs = true }) => {
  const navigate = useNavigate();

  return (<div className="bg-zinc-100 grow h-dvh lg:h-full">
    <div className="w-full  lg:w-[480px] mx-auto flex flex-col items-center px-8 gap-2">
      <div className="w-[160px] mx-auto flex items-center justify-center mt-10 mt-32 mb-8">
        <FailedIcon />
      </div>
      <h1 className="font-semibold text-xl">Payment failure</h1>
      <h2 className="font-medium border-b border-zinc-300 pb-6 text-center">We’ve run into a problem processing your payment, but don’t worry, we haven’t taken a payment from your account yet.</h2>
      {showBacs && <p className="text-zinc-500 text-center mt-6 mb-12">If the problem persists, you can always make a payment via direct transfer using our bank account details. </p>}
      <MerchantButton rounded="full" merchant={merchant} onClick={() => retryUrl ? navigate(retryUrl) : onReturn()} >Return to payment details</MerchantButton>
      {showBacs && <BacsModal
        merchant={merchant}
        reference={reference} />}
    </div>
  </div>);
};

export default PaymentFailed;
